// Shows/hides the main nav on mobile based on user scrolling behavior ------------------------------------ //
// Hides on scroll-down, shows on scroll-up --------------------------------------------------------------- //

var self = {};

self.setScrolling = function(doc) {
  if( $('#klMain').hasClass('mobileMenuOpened')) {
    return;
  }
  var st = $(doc).scrollTop();
  // only do stuff if user has scrolled more than delta threshold
  if(Math.abs(self.lastScrollTop - st) <= self.delta){
    return;
  }

  var hiddenThreshold = $('body').hasClass('mobile-app') ? 1 : self.navbarHeight;
  var $navHeader = $('body').find('.js_top-nav__inner-container');

  if (st > self.lastScrollTop && st > hiddenThreshold) {
    // scroll down
    $('body').removeClass('mobile-main-nav-shown').addClass('mobile-main-nav-hidden');
    TweenLite.to($navHeader, 0.4, {autoAlpha: 0});
  } else if (st + $(window).height() < $(document).height()) {
    // scroll up
    $('body').removeClass('mobile-main-nav-hidden').addClass('mobile-main-nav-shown');
    TweenLite.to($navHeader, 0.4, {autoAlpha: 1});
  }
  self.lastScrollTop = st;

};

export default {
  init: function() {
    self.$nav = $('nav#main-nav');
    self.lastScrollTop = 0;
    self.delta = 5;
    self.navbarHeight = self.$nav.outerHeight();
    console.log('INIT CALLED FOR Kadenze.MobileMainNavScroll');
    $(document).off('scroll.main-nav-scroll').on('scroll.main-nav-scroll', _.debounce( function() {
      self.setScrolling(this);
    }, 10 ));
  }
};

